/* eslint-disable max-len */
import { memo } from 'react';

import { IStylable } from './iconTypes';

function AttachmentIcon({ className, style }: IStylable) {
  return (
    <svg
      width="18"
      height="19"
      viewBox="0 0 18 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}
    >
      <path
        d="M11.5473 5.05452L5.75449 10.8474C4.98846 11.6134 4.98846 12.8554 5.75449 13.6214C6.52052 14.3874 7.7625 14.3874 8.52853 13.6214L14.4845 7.66537C16.0166 6.13332 16.0166 3.64936 14.4845 2.1173C12.9525 0.585248 10.4685 0.585248 8.93647 2.1173L3.06205 7.99173C0.718901 10.3349 0.718901 14.1339 3.06205 16.477C5.40519 18.8202 8.79432 18.516 11.1375 16.1729L16.8487 10.4616"
        stroke="#191414"
        strokeWidth="1.5"
      />
    </svg>
  );
}

export default memo(AttachmentIcon);
